module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - moonjae.6d2e4e7f.pdf";